import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { PageHero } from "../../components/site/PageHero";
import { CTABand } from "../../components/site/CTABand";
import { Stagger, StaggerItem } from "../../components/motion/Reveal";
import { ARTICLES } from "../../data/articles";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export default function Insights() {
  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased" data-testid="insights-page">
      <SiteHeader />
      <PageHero
        crumb="Insights"
        eyebrow="Insights"
        title="Practical knowledge,"
        titleAccent="from the field."
        description="Guides and perspectives on infrastructure, security, networking and automation — written for decision-makers, not engineers."
      />
      <section className="py-16 sm:py-24">
        <div className="nx-wrap">
          <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ARTICLES.map((a) => (
              <StaggerItem key={a.slug}>
                <Link to={`/insights/${a.slug}`} className="group flex flex-col h-full border border-white/10 bg-white/[0.02] hover:border-nx-gold/40 transition-colors duration-300" data-testid={`article-card-${a.slug}`}>
                  <div className="relative overflow-hidden">
                    <img src={a.image} alt={a.title} className="w-full h-52 object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    <span className="absolute top-4 left-4 text-[10px] tracking-[0.22em] uppercase bg-nx-navy/85 backdrop-blur-sm text-nx-goldlight border border-nx-gold/40 px-3 py-1.5">{a.category}</span>
                  </div>
                  <div className="flex flex-col flex-1 p-7">
                    <p className="text-[11px] tracking-[0.18em] uppercase text-slate-500 mb-4">{fmtDate(a.date)} · {a.readTime}</p>
                    <h2 className="font-marcellus text-xl text-white leading-snug">{a.title}</h2>
                    <p className="text-sm text-slate-400 mt-3 leading-relaxed flex-1">{a.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-nx-goldlight">
                      Read article <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
      <CTABand title="Prefer answers in person?" text="Bring your questions to a site assessment — our engineers explain options in plain language, at your premises." />
      <SiteFooter />
    </div>
  );
}
